import styled from 'styled-components';

export const placeholder = styled.div`
    padding: 48px 24px;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    font-size: 16px;
`;
